var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "styled-components";
import { colors } from "../Theme/colors";
import { Div } from "../utils";
const Wrapper = styled(Div) `
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;
const Bounce = styled.div `
  width: 12px;
  height: 12px;
  margin: 0 5px 0 5px;
  background: ${(props) => props.color};
  @-webkit-keyframes sk-bouncedelay {
    0%,
    80%,
    100% {
      -webkit-transform: scale(0);
    }
    40% {
      -webkit-transform: scale(1);
    }
  }
  @keyframes sk-bouncedelay {
    0%,
    80%,
    100% {
      -webkit-transform: scale(0);
      transform: scale(0);
    }
    40% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }
  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
`;
const Bounce1 = styled(Bounce) `
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
`;
const Bounce2 = styled(Bounce) `
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
`;
const SpinnerContainer = styled.div `
  width: 70px;
  text-align: center;
`;
export const Spinner = (_a) => {
    var { color = colors.gray4 } = _a, props = __rest(_a, ["color"]);
    return (React.createElement(Wrapper, Object.assign({}, props),
        React.createElement(SpinnerContainer, null,
            React.createElement(Bounce1, { color: color }),
            React.createElement(Bounce2, { color: color }),
            React.createElement(Bounce, { color: color }))));
};
//# sourceMappingURL=index.js.map